const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        showhireSolidarityCardView: true,
    });
};

const initialState = setInitialState();

const hireSolidarityCardReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.SHOW_HIRE_SOLIDATY_CARD_VIEW:
            return state.merge({
                showhireSolidarityCardView: true,
            });

        case actionTypes.HIDE_HIRE_SOLIDATY_CARD_VIEW:
            return state.merge({
                showhireSolidarityCardView: false,
            });

        default:
            return state;
    }
};

module.exports = hireSolidarityCardReducer;
